const slider = document.querySelector(".similar-licences__grid");

if (slider) {
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener("mousedown", startDragging);
  slider.addEventListener("mouseleave", stopDragging);
  slider.addEventListener("mouseup", stopDragging);
  slider.addEventListener("mousemove", drag);

  function startDragging(e) {
    isDown = true;
    slider.style.cursor = "grabbing";
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
    slider.style.scrollBehavior = "auto";
    slider.style.scrollSnapType = "none";
  }

  function stopDragging() {
    isDown = false;
    slider.style.cursor = "grab";
    slider.style.scrollBehavior = "smooth";

    const itemWidth = 325;
    const currentScroll = slider.scrollLeft;
    const closestSnapPoint = Math.round(currentScroll / itemWidth) * itemWidth;
    slider.scrollTo({ left: closestSnapPoint, behavior: "smooth" });

    setTimeout(() => {
      slider.style.scrollSnapType = "x mandatory";
    }, 300);
  }

  function drag(e) {
    if (!isDown) return;

    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 0.7;
    slider.scrollLeft = scrollLeft - walk;
  }

  slider.style.cursor = "grab";
  slider.style.userSelect = "none";

  const nextButton = document.getElementById("similar-licences__next-btn");
  if (nextButton) {
    nextButton.addEventListener("click", () => {
      const snapWidth = slider.scrollWidth / (slider.children.length - 1);
      slider.scrollLeft += snapWidth;
    });
  }

  const prevButton = document.getElementById("similar-licences__prev-btn");
  if (prevButton) {
    prevButton.addEventListener("click", () => {
      const snapWidth = slider.scrollWidth / (slider.children.length - 1);
      slider.scrollLeft -= snapWidth;
    });
  }
}

const columns = document.querySelectorAll(".licence-info");
const grid = document.querySelector(".similar-licences__grid");

if (grid && columns) {
  styleGrid();
  window.addEventListener("resize", () => {
    styleGrid();
  });
}

function styleGrid() {
  if (columns.length * 325 < grid.getBoundingClientRect().width) {
    const newWidth = grid.getBoundingClientRect().width / columns.length;
    grid.style.gridAutoColumns = `${newWidth}px`;

    const nav = document.querySelector(".similar-licences__nav");
    nav.style.visibility = "hidden";
  } else {
    const nav = document.querySelector(".similar-licences__nav");
    nav.style.visibility = "visible";
  }
}
